const getSSORedirect = () => {
    window.location.assign(
        process.env.REACT_APP_SSO_REDIRECT
    );
};

export default getSSORedirect;
